export const InventoryItemHistoryType = ['ENTRY', 'RFID_ASSIGN', 'RFID_READ', 'MANUAL_VERIFICATION', 'EXPIRATION'];